import React, { useEffect, useState } from "react";
import styled from 'styled-components';

const ModalBase = (props) => {
  const [isVisible, setVisible] = useState(false);
  const fullWidth = props.fullWidth || false;

  useEffect(() => {
    setVisible(props.isVisible);

  },[props]);

  if(isVisible) {
    return (
      <Wrapper className={fullWidth && 'fullWidth'}>
        <ModalBg
          onClick={() => {setVisible(false); props.setModalVisible && props.setModalVisible(false);}}
          bgColor={props.bgColor}
        />
        {props.children}
      </Wrapper>
    );
  } else {
    return(
      <div></div>
    )
  }
}

export default ModalBase;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: 10000;
  &.fullWidth {
    left: 0;
  }
`;

const ModalBg = styled.div`
  background: ${(props) => props.bgColor || "rgba(0, 0, 0, .7)"};
  height: 100vh;
  position: absolute;
  width: 100%;
`;
